import {getUserInfo} from "./app/helpers/storage";
import * as Sentry from "@sentry/react-native";
import {LogBox, Platform} from 'react-native';
import { enableScreens, enableFreeze } from 'react-native-screens';

// Enable native screen containers for better performance
if (Platform.OS !== 'web') {
    enableFreeze(true)
    enableScreens();
}
// ll LogBox warnings and errors (yellow and red boxes)
LogBox.ignoreAllLogs();

Sentry.init({
    dsn: "https://08eefe551d8b6bb635c2de59304a0143@o4509100142952448.ingest.de.sentry.io/4509100145180752",
    // Adds more context data to events (IP address, cookies, user, etc.)
    // For more information, visit: https://docs.sentry.io/platforms/react-native/data-management/data-collected/
    sendDefaultPii: true,
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
    // We recommend adjusting this value in production.
    tracesSampleRate: 0.8,
    // profilesSampleRate is relative to tracesSampleRate.
    // Here, we'll capture profiles for 100% of transactions.
    profilesSampleRate: 0.8,
});

if (!__DEV__) {
    const forward = (type) => {
        const original = console[type];
        console[type] = (...args) => {
            const message = args.map((a) => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');

            // Küldés Sentry-be
            Sentry.addBreadcrumb({
                message,
                level:
                    type === 'log'
                        ? 'log'
                        : type === 'warn'
                            ? 'warning'
                            : type === 'info' ? 'info' : 'error',
                category: 'console',
            });

            if (type === 'error') {
                Sentry.captureMessage(message, 'error');
            }

            // Eredeti log is fusson
            original(...args);
        };
    };

    forward('log');
    forward('info');
    forward('warn');
    forward('error');



    const initializeUserTracking = async () => {
        const user = await getUserInfo();

        // Set user information in Sentry
        Sentry.setUser({
            id: user._id,
            email: user.email,
            name: user.name.first + ' ' + user.name.last,
        });
    };

    // Call the function to initialize user tracking
    initializeUserTracking();
}

import {registerRootComponent} from 'expo';
import App from './App';

export const Toast_Alert_Visibility_Time = 5000;
export const Toast_Alert_Position = "top";


// Initialize Firebase with your config
const firebaseConfig = {
    "apiKey": "AIzaSyDds2hPU2uTuZKr4Vc3MbbtsmfNbZwDpKk",
    "authDomain": "happy-services-v2.firebaseapp.com",
    "projectId": "happy-services-v2",
    "storageBucket": "happy-services-v2.firebasestorage.app",
    "messagingSenderId": "806425959155",
    "appId": "1:806425959155:web:d38abbf6c40c0ef4553586",
    "measurementId": "G-ZWE1T4GEQE"
};

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
